import { useEffect, useRef, useState } from "react";

export const useTimer = (initialTime, onExpire) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);
  const onExpireRef = useRef(onExpire); // 💡 use ref for onExpire

  // keep the ref up-to-date
  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  const start = () => {
    stop(); // cleanup any previous
    setElapsedTime(0);
    setTimeLeft(initialTime);

    timerRef.current = setInterval(() => {
      setElapsedTime((prev) => prev + 1);
      setTimeLeft((prev) => {
        if (prev <= 1) {
          stop();
          onExpireRef.current?.(); // ✅ latest version of onExpire
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stop = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  // Cleanup on unmount
  useEffect(() => stop, []);

  return { timeLeft, elapsedTime, start, stop };
};
